import axiosInstance from '../utils/axiosInstance';

/** Обзор всего парка Оборудования: реестр, состояние, Покрытие. */
export const fetchFleetOverview = async () => {
  const response = await axiosInstance.get('/equipment/overview');
  return response.data?.data ?? {};
};
